import axios from "axios";
import normalizeMsisdn from "../utils/normalizeMsisdn";

const baseUrl = process.env.REACT_APP_API_URL ;

const apiClient = axios.create({
  baseURL: baseUrl,
});

const requireValidMsisdn = (msisdn) => {
  const value = normalizeMsisdn(msisdn);
  if (!value) {
    throw new Error("Please enter a valid Nigerian mobile number");
  }
  return value;
};

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token && !config.headers?.Authorization) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if ([401, 403].includes(error.response?.status)) {
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);

export const fetchGamesApi = async () => {
  return apiClient.get(`/api/games`);
};

export const checkUserSubscriptionApi = async (msisdn) => {
  const normalized = requireValidMsisdn(msisdn);
  return apiClient.get(`/api/subscription/status`, {
    params: { msisdn: normalized },
  });
};

export const getSubscriptionStatusApi = async (msisdn, packType) => {
  const normalized = requireValidMsisdn(msisdn);
  return apiClient.get(`/api/subscription/status`, {
    params: { msisdn: normalized, packType },
  });
};

export const loginApi = async (msisdn) => {
  return apiClient.post(`/api/login`, { msisdn: requireValidMsisdn(msisdn) });
};

export const subscribeApi = async (msisdn, packType) => {
  const normalized = requireValidMsisdn(msisdn);
  return apiClient.post(`/api/subscription/start`, { msisdn: normalized, packType });
};

export const unsubscribeApi = async () => {
  return apiClient.post(`/api/subscription/unsubscribe`);
};

